export default "__VITE_ASSET__7Mv38Xav__"